import { Injectable, OnDestroy, signal } from '@angular/core';
import { fromEvent, merge, Subscription, timer } from 'rxjs';
import { debounceTime, map, throttleTime, filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UserActivityService implements OnDestroy {
    private lastActivityTime = signal<number>(Date.now());
    private activitySubscription: Subscription;

    // Define "Away" as more than 15 minutes of inactivity
    private readonly AWAY_TIMEOUT = 15 * 60 * 1000;

    constructor() {
        const activityEvents = merge(
            fromEvent(window, 'mousemove'),
            fromEvent(window, 'keydown'),
            fromEvent(window, 'click'),
            fromEvent(window, 'scroll'),
            fromEvent(window, 'touchstart'),
            fromEvent(document, 'visibilitychange').pipe(filter(() => document.visibilityState === 'visible'))
        );

        this.activitySubscription = activityEvents.pipe(
            throttleTime(2000), // Only update every 2 seconds at most
        ).subscribe(() => {
            this.lastActivityTime.set(Date.now());
        });
    }

    public isActive(): boolean {
        const inactiveDuration = Date.now() - this.lastActivityTime();
        return inactiveDuration < this.AWAY_TIMEOUT;
    }

    public getLastActivityTime(): number {
        return this.lastActivityTime();
    }

    ngOnDestroy(): void {
        if (this.activitySubscription) {
            this.activitySubscription.unsubscribe();
        }
    }
}
